import React from 'react';
import { addDays, eachDayOfInterval, endOfWeek, format, isSameDay, startOfWeek } from 'date-fns';
import { nl } from 'date-fns/locale';
import { Booking, Settings } from '../../types/booking';
import { dayIsOpen, toMinutes } from '../../utils/availability';
import { dayStats, statusAccent } from '../../utils/agenda';
import { euro } from '../../utils/format';
type Props = {
  anchor: Date;
  days?: number;
  bookings: Booking[];
  settings: Settings;
  services: {
    id: string;
    name: string;
  }[];
  onSelectDate: (iso: string) => void;
  onOpenBooking: (booking: Booking) => void;
};
export function AgendaList({
  anchor,
  days,
  bookings,
  settings,
  services,
  onSelectDate,
  onOpenBooking
}: Props) {
  const range = days ? eachDayOfInterval({
    start: anchor,
    end: addDays(anchor, days - 1)
  }) : eachDayOfInterval({
    start: startOfWeek(anchor, {
      weekStartsOn: 1
    }),
    end: endOfWeek(anchor, {
      weekStartsOn: 1
    })
  });
  return <ul className="space-y-3" data-id="element-128" data-mp="1dtnqo5p77549">
      {range.map(day => {
      const iso = format(day, 'yyyy-MM-dd');
      const open = dayIsOpen(iso, settings);
      const blocked = settings.blockedDates.includes(iso);
      const stats = dayStats(bookings, iso);
      const today = isSameDay(day, new Date());
      const rows = bookings.filter(b => b.date === iso && b.status !== 'cancelled').sort((a, b) => toMinutes(a.time) - toMinutes(b.time));
      return <li key={iso} className="overflow-hidden rounded-2xl border border-edge bg-carbon" data-id="element-129" data-mp="1n88muo1lo4ea">
            <button type="button" onClick={() => onSelectDate(iso)} className="flex w-full items-center gap-3 px-4 py-3 text-left" data-id="element-130" data-mp="1r892gc0fqlmx">
              <span className={`flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl text-sm ${today ? 'bg-ember text-void' : 'bg-panel text-chalk'}`} data-id="element-131" data-mp="1if5vmmkap719">
                <span className="font-display text-base font-extrabold leading-none" data-id="element-132" data-mp="2kt054mxt3ia1">{format(day, 'd')}</span>
                <span className="mt-0.5 text-[10px] uppercase leading-none opacity-80" data-id="element-133" data-mp="2fu6ssxu99xbg">
                  {format(day, 'EEEEEE', {
                locale: nl
              })}
                </span>
              </span>
              <span className="min-w-0 flex-1" data-id="element-134" data-mp="25vrankd7hye3">
                <span className="block truncate text-sm font-medium capitalize text-chalk" data-id="element-135" data-mp="25uy2ceyln0tu">
                  {format(day, 'EEEE d MMMM', {
                locale: nl
              })}
                </span>
                <span className="mt-0.5 block text-xs text-dim" data-id="element-136" data-mp="1x35tg8p83zrd">
                  {blocked ? 'Geblokkeerd' : !open ? 'Gesloten' : stats.count > 0 ? `${stats.count} afspraken · ${euro(stats.revenue)}` : 'Geen afspraken'}
                </span>
              </span>
              {stats.pending > 0 && <span className="shrink-0 rounded-full border border-amber-400/50 px-2 py-0.5 text-[10px] uppercase tracking-[0.1em] text-amber-300" data-id="element-137" data-mp="1e5d3e6zp7kbe">
                  {stats.pending} nieuw
                </span>}
            </button>

            {rows.length > 0 && <ul className="space-y-2 border-t border-edge px-4 py-3" data-id="element-138" data-mp="2oijbpzki9ym">
                {rows.map(booking => {
            const service = services.find(s => s.id === booking.serviceId);
            return <li key={booking.id} data-id="element-139" data-mp="361utlfgzrc1u">
                      <button type="button" onClick={() => onOpenBooking(booking)} className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left ${statusAccent(booking)}`} data-id="element-140" data-mp="3b2918weokjzc">
                        <span className="w-12 shrink-0" data-id="element-141" data-mp="2nd6bf19w7ktr">
                          <span className="block text-xs font-semibold" data-id="element-142" data-mp="2sbrcf2wyy8j9">{booking.time}</span>
                          <span className="block text-[10px] opacity-70" data-id="element-143" data-mp="xvsxqi61n6yc">
                            {Math.round(booking.durationMinutes / 60)}u
                          </span>
                        </span>
                        <span className="min-w-0 flex-1" data-id="element-144" data-mp="17mdqvq2y7j9v">
                          <span className="block truncate text-sm font-medium" data-id="element-145" data-mp="17nyqhu44dsel">{booking.customer.name}</span>
                          <span className="block truncate text-[11px] opacity-80" data-id="element-146" data-mp="1hka0uek5g86e">
                            {service?.name} · {booking.customer.car}
                          </span>
                        </span>
                        <span className="shrink-0 font-display text-sm font-extrabold" data-id="element-147" data-mp="1qli0azyejf22">
                          {euro(booking.amount)}
                        </span>
                      </button>
                    </li>;
          })}
              </ul>}
          </li>;
    })}
    </ul>;
}